// extracted by mini-css-extract-plugin
export default {"logo":"PageCentredFullScreenView_logo__bRJFV","row":"PageCentredFullScreenView_row__s6Xye","title":"PageCentredFullScreenView_title__JNojn"};